import { Paper, withStyles } from '@material-ui/core';
export const PaperModal = withStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 528,
        minHeight: 528,
        margin: 'auto',
        overflowY: 'auto',
        position: 'relative',
        height: '100vh',
        [theme.breakpoints.up('sm')]: {
            height: '75vh',
            maxHeight: '75vh',
            marginTop: '15vh',
            left: -9, // to compensate the width of the scrolling bar
        },
    },
}))(Paper);
